import { FieldDto, ActionTriggerDto } from "../../platform/models";

class FormDto {

    public id: string;

    public title: string;

    public fields: FieldDto[] = [];

    public actionTriggers: ActionTriggerDto[] = [];
}

export { FormDto };